import Request from "../../shared/utils/_request";

class Im {
  constructor() { }
  /**
   * 获取用户签名
   */
  getUserSig() {
    return Request.post('/im/user/get-sig')
  }
  /**
   * 群组列表
   */
  groupList() {
    return Request.post('/im/group/get-list')
  }
  /**
   * 创建单聊
   * @param {{name, type, notification}} payload
   */
  createSingle(payload) {
    return Request.post('/im/single/create', payload)
  }
  /**
   * 创建群聊
   * @param {{name, type, notification}} payload
   */
  createGroup(payload) {
    return Request.post('/im/group/create', payload)
  }/**
   * 编辑群聊
   * @param {{group_id, name, type, notification}} payload
   */
  editGroup(payload) {
    return Request.post('/im/group/update', payload)
  }
  /**
   * 解散群组
   * @param {{group_id}} payload
   */
  dismissGroup(payload) {
    return Request.post('/im/group/disband', payload)
  }
  /**
   * 获取群成员列表
   * @param {{group_id, page, limit}} payload
   */
  groupMemberList(payload) {
    return Request.post('/im/group-user/get-member-list', payload)
  }
  /**
   * 获取待添加用户列表
   * @param {{group_id, tel,page, limit}} payload
   */
  userList(payload) {
    return Request.post('/im/group-user/get-hunter-list', payload)
  }
  /**
   * 批量添加群成员
   * @param {{group_id,ids:'1,2,3'}} payload 
   */
  addUser(payload) {
    return Request.post('/im/group-user/invite', payload)
  }
  /**
   * 批量移除群成员
   * @param {{group_id,ids:'1,2,3'}} payload 
   */
  removeUser(payload) {
    return Request.post('/im/group-user/remove-batch', payload)
  }
  /**
   * 获取关联职位
   * @param {{group_id}} payload 
   */
  getBindedJobs(payload) {
    return Request.post('/im/group-job/get-all', payload)
  }
  /**
   * 关联职位
   * @param {{group_id,job_ids}} payload
   */
  bindJobs(payload) {
    return Request.post('/im/group-job/bind', payload)
  }
  /**
   * 解除关联职位
   * @param {{group_id,job_id}} payload 
   */
  unbindJobs(payload) {
    return Request.post('/im/group-job/delete', payload)
  }

  /**
   * 获取消息列表
   * @param {{sessionType, targetId,count,nextReqMessageID}} payload
   */
  getMessageList(payload) {
    return Request.post('/im/message/search', payload)
  }
  /**
   * 修改群组头像
   * @param {{group_id, face_url}} payload 
   */
  updateGroupAvatar(payload) {
    return Request.post('/im/group/update-face-url', payload)
  }
  /** 
   * 获取简历附件
   */
  getResumeAttachment(payload){
    return Request.post('/job/getResumeAttachment', payload)
  }
}

export const im = new Im();
